<template>
    <div class="w-full h-full">
        <Header
            title="Billing"
            icon="ReceiptText"
        />
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div class="col-span-7">
        <WhiteBox class=""
            title="Upcoming invoice"
            :subText="upcomingInvoiceSubText"
            fullWidthTitle
        >
            <template v-slot:content>
                <div class="grid grid-cols-12 border">
                    <div class="col-span-5 py-2">
                        <p class="text-xs font-semibold px-2">Description</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-semibold px-2">Price</p>
                    </div>
                    <div class="col-span-3 py-2 ">
                        <p class="text-xs font-semibold px-2 text-center">Quantity</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-semibold px-2 text-right">Total</p>
                    </div>
                </div>
                <!--Platform fee-->
                <div 
                    v-if="currentInvoiceData.platformFeeReceivable > 0"
                    class="grid grid-cols-12 border-r border-l border-t"
                >
                    <div class="col-span-5 py-2 ">
                        <p class="text-xs font-medium px-2">Platform fee</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-medium px-2">£ {{ currentInvoiceData.platformFeeReceivable.toFixed(2) }}</p>
                    </div>
                    <div class="col-span-3 py-2 ">
                        <p class="text-xs font-medium px-2 text-center">1</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-medium px-2 text-right">£ {{ currentInvoiceData.platformFeeReceivable.toFixed(2)  }}</p>
                    </div>
                </div>
                <!--Transaction Enrichment Fee-->
                <div 
                    v-if="currentInvoiceData.totalTransactionProcessingReceivable > 0"
                    class="grid grid-cols-12 border-r border-l border-t"
                >
                    <div class="col-span-5 py-2 ">
                        <p class="text-xs font-medium px-2">Transaction enrichment fee</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-medium px-2">£ {{ currentInvoiceData.transactionProcessingFee.toFixed(3) }}</p>
                    </div>
                    <div class="col-span-3 py-2 ">
                        <p class="text-xs font-medium px-2 text-center">{{ currentInvoiceData.processedTransactions }}</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-medium px-2 text-right">£ {{ currentInvoiceData.totalTransactionProcessingReceivable.toFixed(3) }}</p>
                    </div>
                </div>
                <!--Bank Connection Fee-->
                <div 
                    v-if="currentInvoiceData.totalOpenBankingConnectionReceivable > 0"
                    class="grid grid-cols-12 border-r border-l border-t"
                >
                    <div class="col-span-5 py-2 ">
                        <p class="text-xs font-medium px-2">Bank connection fee</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-medium px-2">£ {{ currentInvoiceData.openBankingConnectionFee.toFixed(2) }}</p>
                    </div>
                    <div class="col-span-3 py-2 ">
                        <p class="text-xs font-medium px-2 text-center">{{ currentInvoiceData.openBankingConnection }}</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-medium px-2 text-right">£ {{ currentInvoiceData.totalOpenBankingConnectionReceivable.toFixed(2) }}</p>
                    </div>
                </div>
                <div class="grid grid-cols-12 border">
                    <div class="col-span-5 py-2">
                        <p class="text-xs font-semibold px-2">Total (Excl VAT)</p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-semibold px-2"></p>
                    </div>
                    <div class="col-span-3 py-2 ">
                        <p class="text-xs font-semibold px-2 text-center"></p>
                    </div>
                    <div class="col-span-2 py-2 ">
                        <p class="text-xs font-semibold px-2 text-right">£ {{ parseFloat(currentInvoiceData.invoiceTotal).toFixed(3) }}</p>
                    </div>
                </div>
            </template>
        </WhiteBox>
        </div>
        <div class="col-span-5">
            <WhiteBox class=""
                title="Historical invoices"
                subText="Check your emails for pdf invoice records, or contact our team for assistance"
                fullWidthTitle
            >
                <template v-slot:content>
                    <EasyDataTable
                        :table-min-height="0"
                        :headers="headersTable1"
                        :items="historicData"
                        :loading="loading"
                        v-model:server-options="serverOptions"
                        :server-items-length="serverItemsLength"
                        :hide-footer="true"
                        :no-hover="true"
                    >
                        <template #loading>
                            <div class="p-4 w-full flex justify-center">
                                <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div>
                        </template>
                        <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                        </template>
                        <template #item-startDate="historicData">
                            <div class="w-24 py-1 font-medium">
                                {{ niceDateTime(historicData.startDate)}}
                            </div>
                        </template>
                        <template #item-endDate="historicData">
                            <div class="w-24 py-1 font-medium">
                                {{ niceDateTime(historicData.endDate)}}
                            </div>
                        </template>
                        <template #item-invoiceTotal="historicData">
                            <div class="py-1">
                                <p class="text-xs font-semibold text-right">
                                    £ {{ parseFloat(historicData.invoiceTotal).toFixed(3) }}
                                </p>
                            </div>
                        </template>
                        <template #header-invoiceTotal="header">
                            <div class="w-full text-right">
                                {{ header.text }}
                            </div>
                        </template>
                    </EasyDataTable>
                </template>
            </WhiteBox>
        </div>
    </div>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue"
import WhiteBox from "@/components/WhiteBox.vue";
import { DateTime } from 'luxon';

export default {
	name: "manage-billing",
	components: {
        Header,
        WhiteBox

	},
	props:{
    },

	data() {
		return {

            currentInvoiceData:"",
            historicData:[],
            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            loading:true,
            headersTable1:[
                { text: "Start date", value: "startDate" },
                { text: "End date", value: "endDate"}, 
                {text: "Total", value:"invoiceTotal"} ,        
                
            ],
            apiKeys:[

            ],
        }
	},
	created(){
        this.getCurrentInvoice()
        this.getHistoricInvoices(0,25)

	},
	methods: {
        niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toLocaleString(DateTime.MED)
		},
        async getCurrentInvoice(){
			try {
				const token = localStorage.getItem('token')
                this.loading = true

				const response = await fetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/invoice/current`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()

                    this.currentInvoiceData = object
				}
				
			} catch (error) {
				return;
			}

		},
        async getHistoricInvoices(page,size){
			try {
				const token = localStorage.getItem('token')
                this.loading = true
            
				const response = await fetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/invoice/historic?page=${page}&size=${size}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
                    this.historicData = object.content  
                    this.serverItemsLength = object.totalElements  
                    this.loading = false
				}
				
			} catch (error) {
				return;
			}

		},


	},
	computed: {
        upcomingInvoiceSubText() {
            if (!this.currentInvoiceData) {
                return 'No upcoming invoice data available';
            }
            const startDate = this.niceDateTime(this.currentInvoiceData.startDate);
            const endDate = this.niceDateTime(this.currentInvoiceData.endDate);

            return `For the period from ${startDate} to ${endDate}`;
        }
	},
    mounted() {
        document.title = "Dashboard | Billing";
    },
	watch: {
        serverOptions: {
            deep: true,
            handler(val){
                     this.getHistoricInvoices(val.page-1,val.rowsPerPage)
                }
    }
	}
}
</script>